export default __webpack_public_path__ + "static/media/1962.45a473cf.png";